require('es6-promise').polyfill();
import { Dispatch } from "redux";
import axios from 'axios';
import { IAppState } from "../../classes/app";
import { IAppAction } from "../../classes/action";
import { ActionType } from "./actiontype";
import { IListItem } from "../../classes/list-item";
import { ISearchResultsDTO } from "../../classes/search-results-dto";
import { updateFilterOptions } from "./filters"


let lastRequest: Date = new Date();

export function getListing() {
    return (dispatch: Dispatch, getState: () => IAppState) => {
        const state = getState();
        // @TODO: This string should be updated based on filters.
        const cacheKey = Object.keys(state.filtersState.filters).sort().map(filterKey => `${filterKey}=${state.filtersState.filters[filterKey]}`).join(',');

        if (cacheKey in state.listingState.cache) {
            // some logic is duplicated, possible area for improvement.
            dispatch(updateFilterOptions(state.listingState.cache[cacheKey].filter))
            dispatch(storeListing(cacheKey, [], 0, state.listingState.totalResult, ""));
        } else {

            dispatch(requestListing(cacheKey));
            if (state.listingState.relativeUrl) {
                var query = Object.keys(state.filtersState.filters).sort().map(filterKey => `${filterKey}=${state.filtersState.filters[filterKey]}`).join('&');
                var searchEndPoint = state.listingState.relativeUrl.concat(query);

                axios.get<ISearchResultsDTO>(searchEndPoint+'&RequestTime='+new Date().toISOString()).then(response => {
                    const listing = response.data.currentPageItems;
                    const updatedFilters = response.data.filters;
                    var total = response.data.totalResults;
                    var pages = response.data.numberOfPages;
                    var printResultsText = response.data.printResultText;
                    var thisRequest= new Date(response.data.requestTime);

                    if (thisRequest.getTime() > lastRequest.getTime()) {
                        dispatch(updateFilterOptions(updatedFilters))
                        dispatch(storeListing(cacheKey, listing, pages, total, printResultsText, updatedFilters));
                        lastRequest = thisRequest;
                    }

                }).catch(err => {
                    dispatch(errorListing(err));
                });
            }
        }
    }
}

/**
 * Store the URL for API calls.
 * @param relativeApiUrl The URL the store should utilize for all API calls
 */
export function storeUrl(relativeApiUrl: string): IAppAction {
    return {
        type: ActionType.STORE_BASE_URL,
        value: relativeApiUrl
    }
}

export function goToPage(pageNumber: number): IAppAction {
    return {
        type: ActionType.GO_TO_PAGE,
        value: pageNumber
    };
}

export function setProviderImages(hide: boolean): IAppAction {
    return {
        type: ActionType.SET_PROVIDER_IMAGES,
        value: hide
    }
}

export function setPDFGenerationMessage(message: string): IAppAction {
    return {
        type: ActionType.SET_PDF_GENERATION_MESSAGE,
        value: message
    }
}

export function setCustomDistanceErrorMessage(message: string): IAppAction {
    return {
        type: ActionType.SET_CUSTOM_DISTANCE_ERROR_MESSAGE,
        value: message
    }
}

export function setShowDistanceFilter(hide: boolean): IAppAction {
    return {
        type: ActionType.SET_SHOW_DISTANCE_FILTER,
        value: hide
    }
}

export function setEnableAdvanceLocationLookup(hide: boolean): IAppAction {
    return {
        type: ActionType.SET_ENABLE_ADVANCE_LOCATION_LOOKUP,
        value: hide
    }
}

function requestListing(cacheKey: string): IAppAction {
    return {
        type: ActionType.REQUEST_LIST,
        value: cacheKey
    }
}

function storeListing(cacheKey: string, listing: IListItem[], numberPages: number, totalResult: number, printResultText: string, filter?: any): IAppAction {
    return {
        type: ActionType.STORE_LIST,
        value: {
            cacheKey: cacheKey,
            list: listing,
            numberPages: numberPages,
            totalResult: totalResult,
            printResultText: printResultText,
            filter
        }
    }
}

function errorListing(error: any): IAppAction {
    return {
        type: ActionType.ERROR_LIST,
        value: error
    }
}
